<!-- 旗舰话费 -->
<template>
  <div>

    <!-- 图片标题 -->
    <div class="">
      <div class="pannel-pay-title">
        <img v-if="orderInfo.payType=='alipay'" src="/imgs/title_zfb.jpg" />
        <img v-if="orderInfo.payType=='weixin'" src="/imgs/title_wx.jpg" />
        <img v-if="orderInfo.payType=='douyin'" src="/imgs/title_douyin.png" />
      </div>
    </div>

    <!-- 订单号 -->
    <OrderIdComp :order-info="orderInfo" />

    <!-- 强制说明 -->
    <div class="pannel pannel-center">
      <div class="pay-flow" style="color:yellow; background-color: #4052B6;">
        <p class="no">骚扰机主，全平台将封禁游戏号和手机！</p>
      </div>
    </div>

    <!-- 强制说明2-支付宝专用 -->
    <!-- <div class="pannel pannel-center" v-if="orderInfo.payType=='alipay'">
      <div class="blink" style="font-size:1.3em;"><b>不要使用支付宝转账手机号码</b></div>
    </div> -->

    <!-- 付款流程 -->
    <div class="pannel" v-if="orderInfo.orderId">
      <div class="pay-flow" v-if="orderInfo.payType=='weixin'">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">1、<span style="color:red;">手动</span>打开微信APP</p>
        <p class="no">2、<span style="color:red;">我->服务->手机充值</span>点击进入；</p>
        <p class="no">3、长按手机号码输入框，<span style="color:red;">粘贴充值号码</span>，充值<span style="color:red;">{{orderInfo.amount}}</span>元</p>
        <p class="no">4、<span style="color:red;">请勿复制手机号码转账到微信，否则不会到账，无法追回</span></p>
      </div>
      <div class="pay-flow" v-if="orderInfo.payType=='alipay'&&orderInfo.paykind!=1">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">1、<span style="color:red;">手动</span>打开支付宝APP</p>
        <p class="no">2、首页选择<span style="color:red;">手机充值功能</span></p>
        <p class="no">3、长按手机号码输入框，<span style="color:red;">粘贴充值号码</span>，充值<span style="color:red;">{{orderInfo.amount}}</span>元</p>
        <p class="no">4、<span style="color:red;">请勿复制手机号码转账到支付宝，否则不会到账，无法追回</span></p>
      </div>
      <div class="pay-flow" v-if="orderInfo.payType=='alipay'&&orderInfo.paykind==1">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">请按照订单金额完成支付，订单金额多少就付多少</p>
        <p class="no" style="text-align:center;font-size: 2.1em;">充值：<span style="color:red;">{{orderInfo.amount}}</span>元</p>
        <p class="no" style="text-align:center;">机主姓名：<span style="font-size: 2.1em;color:red;padding-top:1.1em;padding-bottom:1.1em;">{{orderInfo.phoneOwner}}</span></p>
        <p class="no" style="text-align:center;"><span style="">充值时如需验证姓名，请按照上方姓名填写机主姓名；</span></p>
      </div>
      <div class="pay-flow" v-if="orderInfo.payType=='douyin'">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">1、<span style="color:red;">手动</span>打开抖音APP</p>
        <p class="no">2、我-右上角“≡”-我的钱包<span style="color:red;">手机充值</span>功能</p>
        <p class="no">3、长按手机号码输入框,<span style="color:red;">粘贴充值号码</span>，充值<span style="color:red;">{{orderInfo.amount}}</span>元</p>
        <p class="no">4、<span style="color:red;">请勿复制手机号码转账到抖音，否则不会到账，无法追回</span></p>
      </div>
    </div>
    <div class="pannel" v-else>
      <div class="pay-flow">
        <p style="color: #4CAF50;"><b>付款流程：</b></p>
        <p class="no">请稍后</p>
      </div>
    </div>

    <!-- 倒计时 -->
    <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />

    <!--按钮-->
    <div class="pannel-btn" v-if="orderInfo.orderId">
      <!--微信按钮-->
      <button class="btn btn-alip" style="width: 80%;" @click="subPay" v-if="orderInfo.payType=='weixin'">
        点击复制号码+去微信支付
      </button>
      <!--支付宝按钮-->
      <button class="btn btn-alip" style="width: 80%;" @click="subPay" v-if="orderInfo.payType=='alipay'&&orderInfo.paykind!=1">
        点击复制号码+去支付宝支付
      </button>
      <!--支付宝按钮-->
      <div v-if="orderInfo.payType=='alipay'&&orderInfo.paykind==1">
        <a :href="orderInfo.alipUrl" class="btn btn-alip" style="width:70%;">点击打开支付宝</a>
      </div>
      <!--抖音唤醒按钮-->
      <div v-if="orderInfo.payType=='douyin'">
        <a href="snssdk1128://" class="btn btn-alip" style="width:70%;">点击打开抖音</a>
      </div>
    </div>

    <!-- 复制区域 -->
    <div class="pannel" v-if="orderInfo.orderId&&orderInfo.paykind!=1">
      <table class="details">
        <tr>
          <td>手机号码：</td>
          <td>
            <span v-if="copyPhoneIf" style="color: green;"><b>{{orderInfo.phone}}</b></span>
            <span v-else style="color: blue;"><b>{{orderInfo.phone}}</b></span>
            <button v-on:click="copyPhone(true)" class="btn copy">复制号码</button>
          </td>
        </tr>
        <tr v-if="orderInfo.phoneOwner">
          <td>户主姓名：</td>
          <td>
            <span v-if="copyPhoneOwnerIf" style="color: green;"><b>{{orderInfo.phoneOwner}}</b></span>
            <span v-else style="color: blue;"><b>{{orderInfo.phoneOwner}}</b></span>
            <button v-on:click="copyPhoneOwner(true)" class="btn copy">复制姓名</button>
          </td>
        </tr>
        <tr>
          <td>缴费金额：</td>
          <td>
            <span v-if="cptyAmountIf" style="color: green;"><b>{{orderInfo.amount}}</b></span>
            <span v-else style="color: red;"><b>{{orderInfo.amount}}</b></span>
            <button @click="copyAmount(true)" class="btn copy">复制金额</button>
          </td>
        </tr>
      </table>
    </div>

    <!-- 支付宝扫码支付 -->
    <div class="pannel" v-if="orderInfo.orderId&&orderInfo.payType=='alipay'&&orderInfo.paykind==1">
      <div class="pay-flow">
        <p style="color: #4CAF50;text-align:center;"><b>支付宝扫码支付</b></p>
        <p class="no">如跳转支付遇到风控，请截图二维码（或长安图片保存），打开支付宝扫一扫后从相册选择。</p>
        <!--二维码-->
        <div style="padding-bottom:0.5em;">
          <table style="">
            <tr>
              <td style="width: 50%;">
                <div>
                  <img :src="orderInfo.alipQrURL" style="margin: 0 auto;width: 80%;" />
                </div>
              </td>
              <td style="width: 50%;">
                <div class="pay-flow" style="font-size: 0.8em;">
                  <p class="no">1、下载保存二维码图片</p>
                  <p class="no">2、手动打开支付宝APP</p>
                  <p class="no">3、点击右上角扫一扫，选择二维码</p>
                </div>
                <div class="pannel-btn">
                  <a class="btn down" :href="orderInfo.alipQrURL" :download="`${orderInfo.orderId}-${orderInfo.amount}.png`" style="padding:0.4em;">下载</a>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" />

    <!--演示视频-->
    <div class="pannel-simp title" v-if="orderInfo.payType=='douyin'">
      <div style="text-align:center;" v-if="orderInfo.payType=='douyin' && showVideo">
        <img v-if="orderInfo.payType=='douyin'" src="/imgs/douyin01.gif" />
      </div>
      <div class="">
        <button class="btn video" style="width:80%;" @click="showVideo=!showVideo" v-if="!showVideo">显示支付流程视频</button>
      </div>
    </div>

    <!-- 警告事项 -->
    <div class="pannel-simp attention">
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：<span style="color: red;">超时支付，修改金额，修改支付方式，重复支付，</span>无法追回!!!
      </p>
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：<span style="color: red;">次日前未查，</span>无法追回!!!
      </p>
      <p class="">
        <span style="color:#4CAF50;"><b>注意</b></span>：支付成功确认时间<span style="color: red;">5-10分钟</span>,付款后<span style="color: red;">超过10分钟</span>还未到账,请联系客服查单补单!
      </p>
    </div>

    <!-- 弹出框 - 点击复制号码+去微信支付或支付宝的 -->
    <div class="vdf-modal" v-if="showMsg1">
      <div class="vdf-modal-content">
        <div style="font-size: 1.1em;">支付提示</div>
        <div class="pay-flow" style="text-align:left;font-size: 0.9em;">
          <p style="">您已复制手机号码：<span style="color:red;">{{orderInfo.phone}}</span></p>
        </div>
        <div class="pay-flow" style="text-align:left;font-size: 0.9em;" v-if="orderInfo.payType=='weixin'">
          <p style="color: #4CAF50;"><b>付款流程：</b></p>
          <p class="no">1、<span style="color:red;">手动</span>打开微信APP</p>
          <p class="no">2、<span style="color:red;">我->服务->手机充值</span>点击进入；</p>
          <p class="no">3、长按手机号码输入框，<span style="color:red;">粘贴充值号码</span>，充值<span style="color:red;">{{orderInfo.amount}}</span>元</p>
          <p class="no">4、<span style="color:red;">请勿复制手机号码转账到微信，否则不会到账，无法追回</span></p>
        </div>
        <div class="pay-flow" style="text-align:left;font-size: 0.9em;" v-if="orderInfo.payType=='alipay'">
          <p style="color: #4CAF50;"><b>付款流程：</b></p>
          <p class="no">1、<span style="color:red;">手动</span>打开支付宝APP</p>
          <p class="no">2、首页选择<span style="color:red;">手机充值功能</span></p>
          <p class="no">3、长按手机号码输入框，<span style="color:red;">粘贴充值号码</span>，充值<span style="color:red;">{{orderInfo.amount}}</span>元</p>
          <p class="no">4、<span style="color:red;">请勿复制手机号码转账到支付宝，否则不会到账，无法追回</span></p>
        </div>
        <div class="pay-flow" style="text-align:left;font-size: 0.9em;" v-if="orderInfo.payType=='douyin'">
          <p style="color: #4CAF50;"><b>付款流程：</b></p>
          <p class="no">1、<span style="color:red;">手动</span>打开抖音APP</p>
          <p class="no">2、我-右上角“≡”-我的钱包<span style="color:red;">手机充值</span>功能</p>
          <p class="no">3、长按手机号码输入框,<span style="color:red;">粘贴充值号码</span>，充值<span style="color:red;">{{orderInfo.amount}}</span>元</p>
          <p class="no">4、<span style="color:red;">请勿复制手机号码转账到抖音，否则不会到账，无法追回</span></p>
        </div>
        <div v-if="orderInfo.payType=='weixin'&&orderInfo.paykind==1">
          <a href="weixin://" class="btn bankcard-copy btn-weix" @click="subPayClose">确定</a>
        </div>
        <div v-else>
          <button class="btn bankcard-copy" @click="subPayClose">确定</button>
        </div>
      </div>
    </div>
    <!-- 弹出框2 - 简单提示复制陈工 -->
    <div class="vdf-modal" v-if="showCopy">
      <div class="vdf-modal-content">
        复制成功
      </div>
    </div>

    <!-- 弹出框3 - 提示记住机主姓名 -->
    <div class="vdf-modal" v-if="orderInfo.orderId&&showMsg3">
      <div class="vdf-modal-content">
        <div style="font-size: 1.1em;">请记住机主姓名</div>
        <div class="pay-flow" style="text-align:left;font-size: 0.9em;">
          <p style="">充值时如需验证姓名，请输入：</p>
        </div>
        <div style="font-size: 2.1em;color:red;padding-top:1.1em;padding-bottom:1.1em;">{{orderInfo.phoneOwner}}</div>
        <div style="padding-bottom:1.1em;">
          <button class="btn bankcard-copy" @click="subPay3Close">我已记下</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import "@/styles/shanshuo.css"; //
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    alipInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      // 复制相关
      copyPhoneIf: false,
      copyPhoneOwnerIf: false,
      cptyAmountIf: false,
      //
      showVideo: false, //显示视频
      //
      showMsg1: false, // 弹框
      //
      showCopy: false, // 弹框
      //
      showMsg3: true, // 弹框
    };
  },
  computed: {},
  created() {},
  methods: {
    // 点击支付
    subPay() {
      this.copyPhone(false);
      this.showMsg1 = true;
    },
    // 点击支付关闭
    subPayClose() {
      this.showMsg1 = false;
    },
    // 点击关闭
    subPay3Close() {
      this.showMsg3 = false;
    },
    // 复制手机
    copyPhone(ifShow) {
      this.$parent.$parent.copySome(
        this.orderInfo.phone,
        1,
        () => {
          this.copyPhoneIf = true;
          if (ifShow) {
            this.showCopy = true;
            setTimeout(() => {
              this.showCopy = false;
            }, 1000);
          }
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制户主
    copyPhoneOwner(ifShow) {
      this.$parent.$parent.copySome(
        this.orderInfo.phoneOwner.replaceAll("*", ""),
        3,
        () => {
          this.copyPhoneOwnerIf = true;
          if (ifShow) {
            this.showCopy = true;
            setTimeout(() => {
              this.showCopy = false;
            }, 1000);
          }
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
    // 复制金额
    copyAmount() {
      this.$parent.$parent.copySome(
        this.orderInfo.amount,
        2,
        () => {
          this.cptyAmountIf = true;
          this.showCopy = true;
          setTimeout(() => {
            this.showCopy = false;
          }, 1000);
        },
        // eslint-disable-next-line
        (err) => {
          this.$parent.$parent.copyErr();
        }
      );
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
